import {
	Company,
	Customer,
	Railroad,
	Contact,
	PhoneNumber,
} from 'src/shared/api';
import { BillingCompany } from './billing-details.models';

export function mapCompanyToBillingCompany(company: Company): BillingCompany {
	let billingCompany: BillingCompany;
	if (company) {
		const contact: Contact = extractBillingContact(company.contacts) || {};
		const phoneNumber: PhoneNumber =
			extractBillingPhoneNumber(contact.phoneNumbers) || {};
		billingCompany = {
			id: company.id || 0,
			name: company.name,
			employerIdentificationNumber: company.employerIdentificationNumber,
			contactId: contact.id || 0,
			contactFirstName: contact.firstName,
			contactLastName: contact.lastName,
			phoneNumberId: phoneNumber.id || 0,
			phoneNumber:
				(phoneNumber.areaCode || '') +
				(phoneNumber.number || '') +
				(phoneNumber.extension || ''),
			address: company.address,
		};
	}
	return billingCompany;
}

export function mapBillingCompanyToCompany(
	billingCompany: BillingCompany
): Company {
	if (Object.values(billingCompany).some(Boolean)) {
		const company: Company = {
			id: billingCompany.id,
			name: billingCompany.name,
			employerIdentificationNumber:
				billingCompany.employerIdentificationNumber,
			contacts: [
				{
					id: billingCompany.contactId,
					firstName: billingCompany.contactFirstName,
					lastName: billingCompany.contactLastName,
					phoneNumbers: [
						{
							id: billingCompany.phoneNumberId,
							areaCode: extractAreaCode(
								billingCompany.phoneNumber
							),
							number: extractFullNumber(
								billingCompany.phoneNumber
							),
							extension: extractExtension(
								billingCompany.phoneNumber
							),
						},
					],
					emailAddresses: [],
				},
			],
			address: billingCompany.address,
		};
		return company;
	} else {
		return null;
	}
}

export function mapRailroadOrCustomerToCompany(
	billTo: Customer | Railroad
): Company {
	return {
		id: 0,
		name: billTo.companyName,
		employerIdentificationNumber: billTo.employerIdentificationNumber,
		contacts: billTo.contacts,
		address: billTo.address,
	};
}

export function extractBillingContact(contacts: Contact[]): Contact {
	let contact: Contact;
	if (contacts && contacts.length > 0) {
		contact = contacts.find((c) => !/billing/.test(c.role));
		if (!contact) {
			contact = contacts[0];
		}
	}
	return contact;
}

export function extractBillingPhoneNumber(
	phoneNumbers: PhoneNumber[]
): PhoneNumber {
	let phoneNumber: PhoneNumber;
	if (phoneNumbers && phoneNumbers.length > 0) {
		phoneNumber = phoneNumbers.find((c) => !/billing/.test(c.description));
		if (!phoneNumber) {
			phoneNumber = phoneNumbers[0];
		}
	}
	return phoneNumber;
}

export function extractAreaCode(number: string): string {
	return number ? number.slice(0, 3) : number;
}

export function extractFullNumber(number: string): string {
	return number ? number.slice(3, 10) : number;
}

export function extractExtension(number: string): string {
	return number ? number.slice(10) : number;
}
